import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import ErrorBoundary from "./ErrorBoundary";

export default function Layout() {
  const location = useLocation();
  return (
    <div className="min-h-screen bg-[#FAF7EE] text-[#2A2621]">
      <Navbar />
      <main className="max-w-7xl mx-auto px-5 md:px-10 py-8 md:py-12">
        <ErrorBoundary key={location.pathname}>
          <Outlet />
        </ErrorBoundary>
      </main>
      <footer className="border-t border-[#D5CEBF]/60 mt-16">
        <div className="max-w-7xl mx-auto px-5 md:px-10 py-8 text-center">
          <p className="font-heading text-2xl text-[#3D5844]">The Peace Plot</p>
          <p className="text-sm text-[#615A50] mt-1">A Christian devotional collective — walking in faith, together.</p>
        </div>
      </footer>
    </div>
  );
}
